import { UserService } from 'api/generated';
import { ID } from 'components/table/types';
import { QueryError } from 'features/shared/model';
import { UseQueryOptions, useQuery } from 'react-query';

export const useEmployeePersonalHistoryShortDetailsKey = 'EmployeePersonalHistoryShortDetails';

export const fetchEmployeePersonalHistoryShortDetails = async (id: ID, take: number) => {
  const data = await UserService.getUsersPersonalHistoryShortDetails(id as number, take);
  return data;
};

export const useEmployeePersonalHistoryShortDetailsQuery = <TQueryKey extends Array<unknown> = unknown[]>(
  {
    id,
    take
  }: {
    id: ID;
    take: number;
  },
  queryKey?: TQueryKey,
  options?: Omit<
    UseQueryOptions<
      Awaited<ReturnType<typeof fetchEmployeePersonalHistoryShortDetails>>,
      QueryError,
      Awaited<ReturnType<typeof fetchEmployeePersonalHistoryShortDetails>>,
      unknown[]
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >
) =>
  useQuery(
    [useEmployeePersonalHistoryShortDetailsKey, ...(queryKey ?? [{ id }])],
    () => fetchEmployeePersonalHistoryShortDetails(id, take),
    options
  );
